export default __webpack_public_path__ + "static/media/bg.e53f87c0.png";